import React from "react";
import { Check, X } from "lucide-react";
import { PLANS, PLAN_ROWS } from "../data/mock";

function Cell({ value, dark }) {
  if (value === true) {
    return (
      <Check
        size={22}
        strokeWidth={3}
        className={dark ? "text-white" : "text-white"}
      />
    );
  }
  if (value === false) {
    return <X size={22} strokeWidth={3} className="text-white/90" />;
  }
  return (
    <span className="font-serif-body text-[13px] text-white/95 font-semibold text-center leading-tight">
      {value}
    </span>
  );
}

function BasicCell({ value }) {
  if (value === true)
    return <Check size={22} strokeWidth={3} className="text-[#7ecbd6]" />;
  if (value === false)
    return <X size={22} strokeWidth={3} className="text-[#7ecbd6]" />;
  return (
    <span className="font-serif-body text-[13px] text-[#7ecbd6] font-semibold text-center leading-tight">
      {value}
    </span>
  );
}

export default function Pricing() {
  return (
    <section id="pricing" className="bg-[#f4f5f5] py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-5">
        <div className="grid grid-cols-[1.4fr_1fr_1fr_1fr] md:grid-cols-[1.6fr_1fr_1fr_1fr] gap-x-2 md:gap-x-4">
          {/* Header row */}
          <div className="flex items-center">
            <p className="font-serif-display text-[#222] text-lg md:text-2xl font-bold">
              Compare Plans
            </p>
          </div>
          {PLANS.map((plan) => (
            <div
              key={plan.name}
              className={`text-center rounded-t-lg pt-6 pb-4 px-2 ${
                plan.dark
                  ? "bg-[#1ba7c0]"
                  : plan.highlight
                  ? "bg-[#7ecbd6]"
                  : "bg-white"
              }`}
            >
              <p
                className={`font-serif-display text-xl md:text-2xl font-bold ${
                  plan.highlight ? "text-white" : "text-[#7ecbd6]"
                }`}
              >
                {plan.name}
              </p>
              <p
                className={`font-serif-body text-[13px] md:text-[15px] font-bold mt-1 ${
                  plan.highlight ? "text-white" : "text-[#7ecbd6]"
                }`}
              >
                {plan.price}
                {plan.subPrice && (
                  <span className="block font-normal opacity-90">
                    {plan.subPrice}
                  </span>
                )}
              </p>
            </div>
          ))}

          {/* Feature rows */}
          {PLAN_ROWS.map((row, idx) => (
            <React.Fragment key={row.label}>
              <div className="flex items-center py-3 border-t border-gray-200 pr-2">
                <span className="font-serif-body text-[#333] text-[13px] md:text-[15px]">
                  {row.label}
                </span>
              </div>
              {PLANS.map((plan) => {
                const val = plan.values[row.label];
                const isLast = idx === PLAN_ROWS.length - 1;
                return (
                  <div
                    key={plan.name + row.label}
                    className={`flex items-center justify-center py-3 ${
                      plan.dark
                        ? "bg-[#1ba7c0]"
                        : plan.highlight
                        ? "bg-[#7ecbd6]"
                        : "bg-white"
                    } ${isLast ? "rounded-b-lg" : ""}`}
                  >
                    {plan.highlight ? (
                      <Cell value={val} dark={plan.dark} />
                    ) : (
                      <BasicCell value={val} />
                    )}
                  </div>
                );
              })}
            </React.Fragment>
          ))}

          {/* Notation */}
          <div className="pt-3">
            <span className="font-serif-body italic text-[11px] text-[#888]">
              * (After Initial Online Account Creation)
            </span>
          </div>
          <div /> <div /> <div />
        </div>
      </div>
    </section>
  );
}
